import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logTransaction } from '../common/log';
import { handleThunkError } from '../common/util';
import { LogType } from '../models/log.model';

interface IModalState {
  value: number;
}

const initialState: IModalState = {
  value: 0,
};

/// THUNKS

export const incrementAsync = createAsyncThunk<{}, void>(
  'counter/incrementAsync',
  async (e, { rejectWithValue, getState, dispatch }) => {
    logTransaction(LogType.Info, `Incrementing counter +1`, '[counter] incrementAsync');
    try {
      dispatch(increment());

    } catch (err: any) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

/// SLICE

export const counterSlice = createSlice({
  name: 'counter',
  initialState: initialState,
  reducers: {
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    incrementByAmount: (state, action: PayloadAction<number>) => {
      state.value += action.payload;
    },
  },
});

/// REDUCERS

export const { increment, decrement, incrementByAmount } = counterSlice.actions;

/// SELECTORS

// export const selectCount = (state: RootState) => state.counter.value;

export default counterSlice.reducer;
